import React, { useLayoutEffect, useState, useEffect, useRef, useContext, useMemo } from 'react';

import classNames from 'classnames';

import AppContext from '../hooks/AppContext'
import ScroolHook from '../hooks/ScroolHook';

import ZonaDetalhe from '../components/ZonaDetalhe'
import Aguardando from '../components/Aguardando'
import SecondaryPage from '../_template/SecondaryPage'

import {firebaseTimestampToMoment} from '../utils/utils'


const Acompanhamento = (props) => {

  const { setLoading, acompanhamentoSecoes, ocultaZonasConcluidas} = useContext(AppContext);

  const [skeletonShow, setSkeletonShow] = useState(true)  

  //Controle de Loading e Skeleton
  useLayoutEffect(() => {

    //Desativa o loading
    setLoading(false)
    
    //timeout do skeleton caso não tenha resposta do firebase
    setTimeout(()=> setSkeletonShow(false),50);

  }, []);

  useEffect(() => { 

    //se totalização encontrada desabilita skeleton
    if(acompanhamentoSecoes){
      setSkeletonShow(false);
    }

    //se totalização retornou nula do firbase desabilita o skeleton
    if(acompanhamentoSecoes===null){
      setTimeout(()=> setSkeletonShow(false),100);
    }

  }, [acompanhamentoSecoes]);  

  //Processa filtro de acompanhamento de Secoes
  const acompanhamentoSecoesFiltradas = useMemo(() => {
  
    //previne processamento desnecessários quando o objeto de origem não foi carregado
    if(!acompanhamentoSecoes){              
      return acompanhamentoSecoes
    }

    //Objeto padrão para carga de dados
    let acompanhamentoSecoesProcessado = {
      "dataHora" : acompanhamentoSecoes?.dataHora || undefined,
      "secoesLidas": 0,
      "totalSecoes": 0,
      "zonas": []
    }
    
    //Processa acompanhamentoSecoes com base nos filtros e configurações
    acompanhamentoSecoes?.zonas?.forEach( zona =>{       
      
      //oculta concluidas quando configurado
      if(!ocultaZonasConcluidas || zona?.secoesLidas?.length != zona?.totalSecoes){
                        
            //clona dados da zona
            let zonaProcessada = Object.assign({}, zona);                                                                    
            
            //calcula o numero de seções lidas e o total para o grupo de dados
            acompanhamentoSecoesProcessado.secoesLidas += zonaProcessada?.secoesLidas?.length
            acompanhamentoSecoesProcessado.totalSecoes += zonaProcessada?.totalSecoes         

            acompanhamentoSecoesProcessado.zonas?.push(zonaProcessada)
      }       
    })

    if(acompanhamentoSecoesProcessado?.zonas?.length>0){      
      return acompanhamentoSecoesProcessado;    
    }
    return undefined

  },[acompanhamentoSecoes, ocultaZonasConcluidas]);
 
  const renderSkeletons = (num) =>{       
    return(
      Array.from({length: num}, (v, i) => i).map(item =>{                  
        return <ZonaDetalhe key={item} skeleton/>
      })
    )   
  }

  const renderUpdate = () =>{
    if(!acompanhamentoSecoesFiltradas){
      return null
    }
    return <div className="container-subtitle">
      Seções lidas: {
        acompanhamentoSecoesFiltradas?.secoesLidas?.toLocaleString() + "/" + 
        acompanhamentoSecoesFiltradas?.totalSecoes?.toLocaleString() + " em " + 
        firebaseTimestampToMoment(acompanhamentoSecoesFiltradas?.dataHora)
      }
    </div>
  }

  const leftTitle = () =>{
    if(acompanhamentoSecoesFiltradas){
      return "Boletins de Urna (BUs) lidos por Zona Eleitoral"
    }else{
      return "Aguardando a leitura dos Boletins de Urna"
    }
  }

  return (           
      <SecondaryPage titulo={leftTitle()} renderUpdate={renderUpdate()}>
        <ScroolHook listaDados={acompanhamentoSecoesFiltradas}>
          {!acompanhamentoSecoesFiltradas?
            skeletonShow?                                 
                renderSkeletons(8)
              :                                  
                <Aguardando/>                                    
            :
              acompanhamentoSecoesFiltradas?.zonas?.map( item => {       
                return <ZonaDetalhe key={item?.nrZona}
                                zona={item?.nrZona}
                                secoesLidas={item?.secoesLidas}
                                total={item?.totalSecoes} 
                                secoesNLidas={item?.secoesNLidas} progresso/>
              })
          }
        </ScroolHook>

      </SecondaryPage>    
  );
}


export default Acompanhamento;
